<template>
  <div
    class="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-7 2xl:grid-cols-4 gap-4"
  >
    <div
      class="p-4 xl:col-span-2 2xl:col-span-1 rounded-xl space-y-6 lg:space-y-10"
    >
      <div class="pt-2 lg:pt-5 relative w-full">
        <div
          v-if="this.tokenAddress"
          @click="this.setTokenAddress('')"
          type="button"
          class="absolute -top-1 right-0.5 text-gray-400 hover:text-blue-500 cursor-pointer"
        >
          <svg
            class="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
        </div>
        <div
          v-if="this.tokenAddress"
          class="absolute right-0.5 bottom-0.5 text-gray-400 hover:text-blue-500 cursor-pointer"
          @click="this.showHolderDistribution"
        >
          <tooltip text="Holders">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"
              />
            </svg>
          </tooltip>
        </div>
        <div v-if="!this.tokenAddress">
          <div
            class="text-sm mb-1 font-semibold uppercase flex justify-between items-center"
          >
            <div>Token address</div>
          </div>
          <input
            type="text"
            v-model="tokenAddressModel"
            class="block p-2 w-full text-sm bg-transparent rounded-xl border border-gray-500 focus:outline-none focus:ring-0"
          />
        </div>
        <div v-else class="flex flex-col gap-1">
          <div class="w-full flex justify-between items-center gap-2">
            <div class="flex items-center gap-1 text-sm">
              <div class="uppercase">CA:</div>
              <a
                target="_blank"
                :href="this.explorerUrlToken(this.tokenAddress)"
                class="text-blue-500 hover:underline"
              >
                {{ this.shortAddress(this.tokenAddress) }}
              </a>
              <tooltip text="Copy Address">
                <copy :value="this.tokenAddress" width="w-4" />
              </tooltip>
            </div>
            <div
              v-if="this.pairAddress"
              class="flex items-center gap-1 text-sm"
            >
              <div class="uppercase">
                Pair{{ this.uniswapV3 ? "(V3)" : "" }}:
              </div>
              <a
                target="_blank"
                :href="this.explorerUrlToken(this.pairAddress)"
                class="text-blue-500 hover:underline"
              >
                {{ this.shortAddress(this.pairAddress) }}
              </a>
              <tooltip text="Copy Pair Address">
                <copy :value="this.pairAddress" width="w-4" />
              </tooltip>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <div class="font-bold">
              {{ this.metadata.symbol.substring(0, 15) }}
            </div>
            <div class="text-sm">
              ({{ this.metadata.name.substring(0, 50) }})
            </div>
          </div>
          <div class="text-sm flex items-center gap-2">
            <div>{{ this.metadata.totalSupply.toLocaleString() }}</div>
            <div>({{ this.metadata.decimals }} decimals)</div>
          </div>
          <div class="mt-1 flex items-end gap-3 text-gray-400 text-xs">
            <a
              class="flex items-center gap-0.5"
              :href="`https://www.dextools.io/app/en/ether/pair-explorer/${
                this.pairAddress ? this.pairAddress : this.tokenAddress
              }`"
              target="_blank"
            >
              <img src="./../assets/dextools.svg" class="w-4" alt="" />
              <span>DEXTools</span>
            </a>
            <a
              class="flex items-center gap-0.5"
              :href="`https://dexscreener.com/ethereum/${
                this.pairAddress ? this.pairAddress : this.tokenAddress
              }`"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#fff"
                fill-rule="evenodd"
                viewBox="0 0 252 300"
                focusable="false"
                class="w-3"
              >
                <path
                  d="M151.818 106.866c9.177-4.576 20.854-11.312 32.545-20.541 2.465 5.119 2.735 9.586 1.465 13.193-.9 2.542-2.596 4.753-4.826 6.512-2.415 1.901-5.431 3.285-8.765 4.033-6.326 1.425-13.712.593-20.419-3.197m1.591 46.886l12.148 7.017c-24.804 13.902-31.547 39.716-39.557 64.859-8.009-25.143-14.753-50.957-39.556-64.859l12.148-7.017a5.95 5.95 0 003.84-5.845c-1.113-23.547 5.245-33.96 13.821-40.498 3.076-2.342 6.434-3.518 9.747-3.518s6.671 1.176 9.748 3.518c8.576 6.538 14.934 16.951 13.821 40.498a5.95 5.95 0 003.84 5.845zM126 0c14.042.377 28.119 3.103 40.336 8.406 8.46 3.677 16.354 8.534 23.502 14.342 3.228 2.622 5.886 5.155 8.814 8.071 7.897.273 19.438-8.5 24.796-16.709-9.221 30.23-51.299 65.929-80.43 79.589-.012-.005-.02-.012-.029-.018-5.228-3.992-11.108-5.988-16.989-5.988s-11.76 1.996-16.988 5.988c-.009.005-.017.014-.029.018-29.132-13.66-71.209-49.359-80.43-79.589 5.357 8.209 16.898 16.982 24.795 16.709 2.929-2.915 5.587-5.449 8.814-8.071C69.31 16.94 77.204 12.083 85.664 8.406 97.882 3.103 111.959.377 126 0m-25.818 106.866c-9.176-4.576-20.854-11.312-32.544-20.541-2.465 5.119-2.735 9.586-1.466 13.193.901 2.542 2.597 4.753 4.826 6.512 2.416 1.901 5.432 3.285 8.766 4.033 6.326 1.425 13.711.593 20.418-3.197"
                ></path>
                <path
                  d="M197.167 75.016c6.436-6.495 12.107-13.684 16.667-20.099l2.316 4.359c7.456 14.917 11.33 29.774 11.33 46.494l-.016 26.532.14 13.754c.54 33.766 7.846 67.929 24.396 99.193l-34.627-27.922-24.501 39.759-25.74-24.231L126 299.604l-41.132-66.748-25.739 24.231-24.501-39.759L0 245.25c16.55-31.264 23.856-65.427 24.397-99.193l.14-13.754-.016-26.532c0-16.721 3.873-31.578 11.331-46.494l2.315-4.359c4.56 6.415 10.23 13.603 16.667 20.099l-2.01 4.175c-3.905 8.109-5.198 17.176-2.156 25.799 1.961 5.554 5.54 10.317 10.154 13.953 4.48 3.531 9.782 5.911 15.333 7.161 3.616.814 7.3 1.149 10.96 1.035-.854 4.841-1.227 9.862-1.251 14.978L53.2 160.984l25.206 14.129a41.926 41.926 0 015.734 3.869c20.781 18.658 33.275 73.855 41.861 100.816 8.587-26.961 21.08-82.158 41.862-100.816a41.865 41.865 0 015.734-3.869l25.206-14.129-32.665-18.866c-.024-5.116-.397-10.137-1.251-14.978 3.66.114 7.344-.221 10.96-1.035 5.551-1.25 10.854-3.63 15.333-7.161 4.613-3.636 8.193-8.399 10.153-13.953 3.043-8.623 1.749-17.689-2.155-25.799l-2.01-4.175z"
                ></path>
              </svg>
              <span>DEXScreener</span>
            </a>
          </div>
        </div>
      </div>
      <div class="">
        <div class="flex justify-between items-center">
          <div class="flex gap-4 items-center">
            <div class="flex gap-2 items-center">
              <label class="block text-sm font-bold uppercase">Wallets </label>
              <div class="text-base text-red-400">
                {{ this.screen.length }}/{{ this.wallets.length }}
              </div>
            </div>
            <div class="flex items-center gap-1.5">
              <tooltip text="Create a Wallet">
                <div class="cursor-pointer" @click="this.createWallet">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 text-gray-500 hover:text-blue-600"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                </div>
              </tooltip>
              <tooltip text="Import Wallet">
                <div class="cursor-pointer" @click="this.showImportWallet">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-[21px] text-gray-500 hover:text-blue-600"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859M12 3v8.25m0 0-3-3m3 3 3-3"
                    />
                  </svg>
                </div>
              </tooltip>
              <tooltip text="Export Wallet">
                <div class="cursor-pointer" @click="this.showExportWallet">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-[22px] text-gray-500 hover:text-blue-600"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
                    />
                  </svg>
                </div>
              </tooltip>
              <tooltip text="Remove Wallet">
                <div class="cursor-pointer" @click="this.showRemoveWallet">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-[21px] text-gray-500 hover:text-red-600"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                    />
                  </svg>
                </div>
              </tooltip>
            </div>
          </div>
          <div class="flex gap-3 items-center">
            <tooltip text="Collect Balance">
              <div
                class="cursor-pointer flex gap-1 items-center"
                @click="this.openCollectBalanceModal = true"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-5 text-gray-500 hover:text-blue-600"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
                  />
                </svg>
              </div>
            </tooltip>
            <tooltip text="Show All Wallet">
              <div
                class="cursor-pointer flex gap-1 items-center"
                @click="this.hiddenWallet([])"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-5 text-gray-500 hover:text-blue-600"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M7.5 3.75H6A2.25 2.25 0 0 0 3.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0 1 20.25 6v1.5m0 9V18A2.25 2.25 0 0 1 18 20.25h-1.5m-9 0H6A2.25 2.25 0 0 1 3.75 18v-1.5M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                  />
                </svg>
              </div>
            </tooltip>
          </div>
        </div>
        <div class="mt-2 grid grid-cols-2 gap-3 justify-between items-center">
          <div
            class="relative flex flex-col justify-center items-center text-sm bg-neutral-700 p-3 rounded-xl"
          >
            <div class="text-base text-red-400">
              {{ balanceFormat(this.totalBalanceNative) }}
            </div>
            <div>{{ this.wrappedToken }}</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-5 absolute top-2 right-2 cursor-pointer text-gray-500 hover:text-blue-500"
              :class="{
                'animate-spin text-blue-500':
                  this.activeFetchTotalBalanceNative,
              }"
              @click="this.fetchTotalBalanceNative()"
            >
              <path
                fill-rule="evenodd"
                d="M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div
            v-if="this.tokenAddress"
            class="relative flex flex-col justify-center items-center text-sm bg-neutral-700 p-3 rounded-xl"
          >
            <div class="text-base text-red-400">
              {{ balanceFormat(this.totalBalanceToken) }}
            </div>
            <div class="flex gap-1 items-center">
              <div v-if="this.totalBalanceToken" class="text-yellow-200">
                (~{{
                  (
                    (this.totalBalanceToken / this.metadata.totalSupply) *
                    100
                  ).toFixed(2)
                }}%)
              </div>
              <div>{{ this.metadata.symbol ?? "Token" }}</div>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-5 absolute top-2 right-2 cursor-pointer text-gray-500 hover:text-blue-500"
              :class="{
                'animate-spin text-blue-500': this.activeFetchTotalBalanceToken,
              }"
              @click="this.fetchTotalBalanceToken()"
            >
              <path
                fill-rule="evenodd"
                d="M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>
      <div
        id="config-accordion"
        class="bg-neutral-700 rounded-xl overflow-hidden"
      >
        <div
          id="config-accordion-heading"
          class="p-2 flex justify-between items-center gap-2 cursor-pointer"
        >
          <div class="text-gray-400 hover:text-gray-300">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
              />
            </svg>
          </div>
          <div class="flex items-center gap-2 text-gray-300">
            <div class="text-xs uppercase">Gas limit: {{ this.gasLimit }}</div>
            <div class="w-[2px] h-[9.5px] bg-gray-400"></div>
            <div class="text-xs uppercase">Gas price: {{ this.gasPrice }}</div>
            <div class="w-[2px] h-[9.5px] bg-gray-400"></div>
            <div class="text-xs uppercase">Slippage: {{ this.slippage }}</div>
            <svg
              ref="config-accordion-icon"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-[18xp] h-[18px] shrink-0 text-gray-400"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m19.5 8.25-7.5 7.5-7.5-7.5"
              />
            </svg>
          </div>
        </div>
        <div id="config-accordion-body" class="hidden p-2 space-y-3">
          <div>
            <label class="block text-sm mb-1 font-semibold uppercase">
              RPC Url
            </label>
            <input
              type="text"
              v-model="rpcUrlModel"
              class="block p-2 w-full text-sm bg-transparent rounded-xl border border-gray-500 focus:outline-none focus:ring-0"
            />
          </div>
          <div class="grid grid-cols-3 gap-2">
            <div>
              <label class="block text-sm mb-1 font-semibold uppercase">
                Gas limit
              </label>
              <input
                type="text"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
                v-model="gasLimitModel"
                class="block p-2 w-full text-sm bg-transparent rounded-xl border border-gray-500 focus:outline-none focus:ring-0"
              />
            </div>
            <div>
              <label class="block text-sm mb-1 font-semibold uppercase">
                Gas price
              </label>
              <input
                type="text"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
                v-model="gasPriceModel"
                class="block p-2 w-full text-sm bg-transparent rounded-xl border border-gray-500 focus:outline-none focus:ring-0"
              />
            </div>
            <div>
              <label class="block text-sm mb-1 font-semibold uppercase">
                Slippage
              </label>
              <input
                type="text"
                v-model="slippageModel"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
                class="block p-2 w-full text-sm bg-transparent rounded-xl border border-gray-500 focus:outline-none focus:ring-0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="relative pl-4 lg:pl-0 lg:h-[calc(100vh-100px)] pt-0 lg:col-span-2 xl:col-span-5 2xl:col-span-3"
    >
      <div
        class="space-y-4 xl:space-y-5 py-2 pr-4 lg:overflow-y-auto overflow-x-hidden"
        :class="{
          'lg:h-[calc(100vh-450px)] 2xl:h-[calc(100vh-550px)]':
            this.openChartDrawerSwipe,
          'lg:h-[calc(100vh-100px)]': !this.openChartDrawerSwipe,
        }"
      >
        <wallet
          v-for="wallet in this.screen"
          :key="wallet.address"
          :wallet="wallet"
          :refresh-wallet="this.refreshWallet"
        ></wallet>
        <chart-drawer-swipe
          v-if="!this.isMobile && this.pairAddress"
          :address="this.pairAddress"
          :chain="this.chain.dexToolsPathName"
          :open="this.openChartDrawerSwipe"
        ></chart-drawer-swipe>
      </div>
    </div>
    <collect-balance-modal :open="this.openCollectBalanceModal" />
  </div>
</template>

<script>
import Wallet from "@/components/Ethereum/Wallet.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Tooltip from "@/components/Tooltip.vue";
import { ethers } from "ethers";
import Copy from "@/components/Copy.vue";
import { Accordion } from "flowbite";
import CollectBalanceModal from "@/components/Ethereum/CollectBalanceModal.vue";
import ChartDrawerSwipe from "@/components/ChartDrawerSwipe.vue";
export default {
  name: "EthereumTradingView",
  components: { ChartDrawerSwipe, CollectBalanceModal, Copy, Tooltip, Wallet },
  data() {
    return {
      activeRefreshWallet: false,
      activeFetchTotalBalanceNative: false,
      activeFetchTotalBalanceToken: false,
      refreshWallet: "",
      intervalUpdateWalletOnServer: null,
      intervalFetchTokenPriceInETH: null,
      intervalFetchPairAddress: null,
      openCollectBalanceModal: false,
      configAccordion: null,
      openChartDrawerSwipe: false,
    };
  },
  computed: {
    ...mapState("ethereum", [
      "metadata",
      "tokenAddress",
      "pairAddress",
      "rpcUrl",
      "gasLimit",
      "gasPrice",
      "slippage",
      "uniswapV3",
    ]),
    ...mapState("network", ["chain"]),
    ...mapGetters("app", ["balanceFormat", "isMobile"]),
    ...mapGetters("network", [
      "chainList",
      "shortAddress",
      "explorerUrlToken",
      "wrappedToken",
    ]),
    ...mapGetters("wallet", [
      "totalBalanceNative",
      "totalBalanceToken",
      "screen",
      "wallets",
      "hidden",
    ]),
    ...mapGetters("ethereum", ["getBalanceNative", "getBalanceToken"]),
    tokenAddressModel: {
      get() {
        return this.tokenAddress;
      },
      async set(tokenAddress) {
        if (tokenAddress && this.tokenAddress !== tokenAddress) {
          try {
            if (!ethers.utils.isAddress(tokenAddress)) {
              this.$store.commit("toast/add", {
                type: "danger",
                title: "Invalid address.",
              });
              await this.setTokenAddress("");
            } else {
              await this.setTokenAddress(tokenAddress);
              if (!this.pairAddress) {
                clearInterval(this.intervalFetchPairAddress);
                this.startFetchPairAddress();
              }
            }
          } catch (e) {
            this.$store.commit("toast/add", {
              type: "danger",
              title: e.message,
            });
            await this.setTokenAddress("");
          }
        }
      },
    },
    rpcUrlModel: {
      get() {
        return this.rpcUrl;
      },
      set(rpcUrl) {
        this.setRpcUrl(rpcUrl);
        this.updateLocalStorage({ rpcUrl });
        this.ethereumInit();
      },
    },
    gasLimitModel: {
      get() {
        return this.gasLimit;
      },
      set(gasLimit) {
        gasLimit = Number(gasLimit);
        this.setGasLimit(gasLimit);
        this.updateLocalStorage({ gasLimit });
      },
    },
    gasPriceModel: {
      get() {
        return this.gasPrice;
      },
      set(gasPrice) {
        gasPrice = Number(gasPrice);
        this.setGasPrice(gasPrice);
        this.updateLocalStorage({ gasPrice });
      },
    },
    slippageModel: {
      get() {
        return this.slippage;
      },
      set(slippage) {
        slippage = Number(slippage);
        this.setSlippage(slippage);
        this.updateLocalStorage({ slippage });
      },
    },
  },
  watch: {},
  methods: {
    ...mapActions("wallet", { createWallet: "create", walletInit: "init" }),
    ...mapActions("wallet", [
      "updateBalanceNative",
      "updateBalanceToken",
      "update",
      "hiddenWallet",
    ]),
    ...mapActions("ethereum", { ethereumInit: "init" }),
    ...mapActions("ethereum", [
      "setTokenAddress",
      "getPairAddress",
      "getTokenPriceInETH",
    ]),
    ...mapActions("removeWallet", { showRemoveWallet: "show" }),
    ...mapActions("importWallet", { showImportWallet: "show" }),
    ...mapActions("exportWallet", { showExportWallet: "show" }),
    ...mapActions("holderDistribution", { showHolderDistribution: "show" }),
    ...mapMutations("ethereum", [
      "setRpcUrl",
      "setGasLimit",
      "setGasPrice",
      "setSlippage",
    ]),
    ...mapActions("network", ["updateLocalStorage"]),
    startUpdateWalletOnServer() {
      this.intervalUpdateWalletOnServer = setInterval(async () => {
        await this.update();
      }, 10000);
    },
    async startRefreshWallet() {
      let index = 0;
      while (this.activeRefreshWallet) {
        await new Promise((resolve) => setTimeout(resolve, 3000));
        if (this.screen[index] && this.screen[index].address) {
          this.refreshWallet = this.screen[index].address;
        } else {
          this.refreshWallet = "";
        }
        index++;
        if (index > this.screen.length) {
          index = 0;
        }
      }
    },
    startFetchTokenPriceInETH() {
      this.intervalFetchTokenPriceInETH = setInterval(async () => {
        if (!this.tokenAddress) {
          clearInterval(this.intervalFetchTokenPriceInETH);
        } else {
          await this.getTokenPriceInETH();
        }
      }, 4000);
    },
    startFetchPairAddress() {
      this.intervalFetchPairAddress = setInterval(async () => {
        if (!this.tokenAddress) {
          clearInterval(this.intervalFetchPairAddress);
        } else {
          if (!this.pairAddress) {
            await this.getPairAddress();
          } else {
            clearInterval(this.intervalFetchPairAddress);
            clearInterval(this.intervalFetchTokenPriceInETH);
            this.startFetchTokenPriceInETH();
          }
        }
      }, 3000);
    },
    async fetchTotalBalanceNative(wallets = [], index = 0) {
      this.activeFetchTotalBalanceNative = true;
      if (wallets.length <= 0) {
        wallets = this.hidden;
      }
      if (wallets.length > 0) {
        const wallet = wallets[index];
        let balance = await this.getBalanceNative(wallet.address);
        balance = Number(ethers.utils.formatEther(balance));
        await this.updateBalanceNative({ address: wallet.address, balance });
        index++;
        if (wallets.length > index) {
          return await this.fetchTotalBalanceNative(wallets, index);
        }
      }
      this.activeFetchTotalBalanceNative = false;
    },
    async fetchTotalBalanceToken(wallets = [], index = 0) {
      this.activeFetchTotalBalanceToken = true;
      if (wallets.length <= 0) {
        wallets = this.hidden;
      }
      if (wallets.length > 0) {
        const wallet = wallets[index];
        let balance = await this.getBalanceToken(wallet.address);
        balance = Number(
          ethers.utils.formatUnits(balance, this.metadata.decimals)
        );
        await this.updateBalanceToken({ address: wallet.address, balance });
        index++;
        if (wallets.length > index) {
          return await this.fetchTotalBalanceToken(wallets, index);
        }
      }
      this.activeFetchTotalBalanceToken = false;
    },
  },
  async beforeMount() {
    await this.walletInit();
    await this.ethereumInit();
    if (this.tokenAddress) {
      if (!this.pairAddress) {
        this.startFetchPairAddress();
      } else {
        this.startFetchTokenPriceInETH();
      }
    }
    this.startUpdateWalletOnServer();
  },
  async beforeUnmount() {
    await this.setTokenAddress("");
    this.activeRefreshWallet = false;
    clearInterval(this.intervalUpdateWalletOnServer);
    clearInterval(this.intervalFetchTokenPriceInETH);
    clearInterval(this.intervalFetchPairAddress);
  },
  async mounted() {
    this.configAccordion = new Accordion(
      document.getElementById("config-accordion"),
      [
        {
          id: "config-accordion-heading",
          triggerEl: document.querySelector("#config-accordion-heading"),
          targetEl: document.querySelector("#config-accordion-body"),
          active: false,
        },
      ],
      {
        alwaysOpen: true,
        activeClasses: "bg-neutral-700",
        inactiveClasses: "bg-transparent",
        onOpen: () => {
          this.$refs["config-accordion-icon"].classList.add("rotate-180");
        },
        onClose: () => {
          this.$refs["config-accordion-icon"].classList.remove("rotate-180");
        },
      }
    );
    this.activeRefreshWallet = true;
    await this.startRefreshWallet();
  },
};
</script>
